export const APP_URL: string = import.meta.env.VUE_APP_APP_URL
export const TM_URL: string = import.meta.env.VUE_APP_TM_URL
export const TM_ATTACHMENT_URL: string = import.meta.env.VUE_APP_TM_ATTACHMENT_URL
export const AWS_S3_URL: string = import.meta.env.VUE_APP_AWS_S3_URL

export const DEFAULT_CONFIRMATION_CODE_LENGTH = 4

export const TM_STAGING_HOST: string = import.meta.env.VUE_APP_STAGING_HOST
